<div class="flex flex-col items-center">
  <label class="block text-base font-medium text-slate-700 mb-3 w-full">
    <span translate>feature.ponctual-schedule.Date :</span>
  </label>

  @if (loading) {
    <app-loading-spinner-fuse [diameter]="40" [message]="'common.loading'"></app-loading-spinner-fuse>
  } @else {
    <div class="space-y-4 w-full max-w-80">
      <!-- Navigation mois -->
      <div class="flex items-center justify-between">
        <button 
          (click)="previousMonth()" 
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-slate-100 text-slate-600"
          aria-label="Mois précédent">
          <mat-icon class="!text-base">chevron_left</mat-icon>
        </button>

        <span class="text-lg font-semibold text-slate-800">{{ capitalizedMonthName }} {{ year }}</span>

        <button 
          (click)="nextMonth()" 
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-slate-100 text-slate-600"
          aria-label="Mois suivant">
          <mat-icon class="!text-base">chevron_right</mat-icon>
        </button>
      </div>

      <!-- Calendrier grille -->
      <div>
        <!-- En-têtes jours -->
        <div class="grid grid-cols-7 gap-1 mb-2">
          <div class="text-center text-sm font-medium text-slate-500 py-2">L</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">M</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">M</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">J</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">V</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">S</div>
          <div class="text-center text-sm font-medium text-slate-500 py-2">D</div>
        </div>

        <!-- Grille des jours -->
        <div class="grid grid-cols-7 gap-1">
          @for (day of calendarDays; track $index) {
            <button 
              [disabled]="day === null || !isDayAvailable(day)"
              (click)="selectDay(day)" 
              type="button" 
              class="aspect-square rounded-lg font-medium transition"
              [ngClass]="{
                'bg-primary-600 text-white hover:bg-primary-700': isDaySelected(day) && isDayAvailable(day),
                'bg-white border border-slate-200 hover:bg-slate-50 text-slate-800': day !== null && !isDaySelected(day) && isDayAvailable(day),
                'bg-slate-50 text-slate-300 cursor-not-allowed': day !== null && !isDayAvailable(day),
                'invisible': day === null
              }"
              [attr.aria-label]="day ? 'Jour ' + day : null"
              [attr.aria-disabled]="!isDayAvailable(day)">
              {{ day || '' }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
